import {ChangeDetectorRef, Component, ElementRef, Input, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {Observable} from "rxjs";
import {ModalService} from "../../../../../services/ui/modal.service";
import {SubscriptionLike as ISubscription} from "rxjs/internal/types";
import {CacheService} from "../../../../../services/sys/cache.service";

@Component({
    selector: 'efast-modal-not-found',
    templateUrl: 'efast-modal-not-found.component.html',
    styleUrls: ['./efast-modal-not-found.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EfastModalNotFoundComponent implements OnInit {
    modalSubscription: ISubscription | null = null;
    protected show: boolean = false;
    protected msg: string = "";
    protected btnLabel: string = "";

    constructor(private el: ElementRef,
                private modalService: ModalService,
                private cacheService: CacheService) {
        this.modalSubscription = this.modalService.modalNotFoundServiceSubject.subscribe(data => this.modalChangeEvent(data));
    }
    private modalChangeEvent(data) {
        if (this.modalService.isShow()) {
            this.show = true;
            this.el.nativeElement.classList.add('sshow');
            
            //find and focus on close button when modal is shown - Sec. 508 standard
            var closeBtn = this.el.nativeElement.querySelector(".closeBtn");
            setTimeout(function(){closeBtn.focus(); }, 10);
        }
        else {
            this.show = false;
            this.el.nativeElement.classList.add('hhidden')
        }

    }
    ngOnInit() {

        this.msg = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONModalNotFoundMsg');
        this.btnLabel = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONModalNotFoundBtnLbl');
    }
    close() {
        this.modalService.setShow(false);
        this.show = false;
        this.el.nativeElement.classList.remove('sshow')
        this.el.nativeElement.classList.add('hhidden')
    }
}
